import Macy from 'macy';
import _throttle from "lodash.throttle";

const grid = () => {

  const grids = document.querySelectorAll('[data-macy-grid]');

  if(grids) {
    grids.forEach(grid => {

      const btn = grid.parentNode.querySelector('.c-card-grid__toggle');
      if(btn) {
        btn.addEventListener('click',(e) => {
          e.preventDefault();
          grid.classList.add('is-active');
        });
      }


      const { macyGrid } = grid.dataset
      const additionalSettings = JSON.parse(macyGrid);
      const baseOptions = {
        container: grid,
        trueOrder: true,
        margin: {
          x: 24,
          y: 24,
        },
        columns: 3,
        breakAt: {
          1023: {
            margin: {
              x: 0,
              y: 12,
            },
            columns: 1
          }
        }
      }

      const macyInstance = Macy({ ...baseOptions, ...additionalSettings});


      setTimeout(() => {
        gridHeight(grid);
      },500)
      window.addEventListener('resize', _throttle(() => {
        gridHeight(grid);
      },500));

    });
  }

};

const gridHeight = (gridEl) => {

  const itemCount = gridEl.children.length;

  let mq = window.matchMedia('(min-width: 1024px)');
  if (mq.matches === true) {
    if(itemCount > 13) {
      gridEl.classList.add('is-overflown');
      gridEl.style.setProperty('--card-grid-height', `${gridEl.children[1].getBoundingClientRect().height * 4}px`)
    } else {
      gridEl.classList.remove('is-overflown')
    }
  } else {
    if(itemCount > 3) {
      gridEl.classList.add('is-overflown');
      gridEl.style.setProperty('--card-grid-height', `${gridEl.children[1].getBoundingClientRect().height * 3}px`)
    } else {
      gridEl.classList.remove('is-overflown')
    }
  }
}

grid();
